export default [
  {
    path: '/hotelOrderList',
    component: () => import('../pages/hotelOrderList/index.vue'),
    name: 'HotelOrderList',
    meta: {
      title: '我的订单',
      activeBar: 'order'
    },
  },
  {
    path: '/hotelOrder',
    component: () => import('../pages/hotelOrder/index.vue'),
    name: 'HotelOrder',
    meta: {
      title: '订单详情',
      activeBar: 'order'
    },
  },
  {
    path: '/hotelPay',
    component: () => import('../pages/hotelPay/index.vue'),
    name: 'HotelPay',
    meta: {
      title: '收银台',
      activeBar: 'order'
    },
  },
  {
    path: '/hotelCancelOrder',
    component: () => import('../pages/hotelCancelOrder/index.vue'),
    name: 'HotelCancelOrder',
    meta: {
      title: '取消订单',
      activeBar: 'order'
    },
  },
]